export default {
    parts: [
        'container',
        'title',
        'subtitle',
        'selectWrapper',
        'applyCTA',
        'appliedRow',
        'appliedText',
        'removeLink',
        'footer',
        'footerPoints'
    ],
    baseStyle: (props) => ({
        container: {
            bg: 'webTheme.backgroundPrimaryBrand',
            p: 3,
            display: 'flex',
            flexDirection: 'column'
        },
        title: {
            textStyle: 'webH4',
            color: 'webTypo.textBrandLoyalty',
            mb: 1
        },
        subtitle: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textPrimary',
            pb: 3,
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeSecondary',
            mb: 3
        },
        selectWrapper: {
            display: 'flex',
            flexDirection: 'column',
            mb: 4
        },
        applyCTA: {
            mt: 2,
            _disabled: {
                backgroundColor: 'transparent',
                borderColor: 'webTypo.textPrimary',
                color: 'webTypo.textPrimary',
                opacity: 1,
                pointerEvents: 'none'
            },
        },
        appliedRow: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            backgroundColor: 'webTheme.fieldDefault',
            padding: '14px 16px',
            mb: 4
        },
        appliedText: {
            textStyle: 'bodyXsSRegular'
        },
        removeLink: {
            ...(props?.theme?.textStyles?.bodyXsLink || {}),
            height: 'auto',
            minH: 'auto'
        },
        footer: {
            textStyle: 'bodyXsRegular',
            color: 'webTypo.textPrimary'
        },
        footerPoints: {
            as: 'span',
            textStyle: 'bodyXsBold'
        },
        borderDivider: {
            borderBottom: '1px solid',
            borderColor: 'webTheme.strokeSecondary',
            mb: '12px'
        }
    })
}
